function fillRobotCheck(formid) {
    var rbt, rbtobj, rbtarea;
    rbt = document.getElementById("rbt-" + formid);
    rbtobj = document.getElementById("robotsid-" + formid);
    if (rbt != null && rbtobj != null) {
        switch (rbt.value) {
            case "1":
                rbtobj.value = "january";
                break;
            case "2":
                rbtobj.value = "white";
                break;
            case "3":
                rbtobj.value = "night";
                break;
            case "4":
                rbtobj.value = "day";
                break;
        }

        rbtarea = document.getElementById("robots-" + formid);
        if (rbtarea != null) rbtarea.style.display = "none";
        rbtarea = document.getElementById("robots-1-" + formid);
        if (rbtarea != null) rbtarea.style.display = "none";
        rbtarea = document.getElementById("robots-2-" + formid);
        if (rbtarea != null) rbtarea.style.display = "none";
    }
}

function checkSearch(form) {
    if (isEmpty(form.search.value) || (form.search.value == 'Search...')) {
        window.dataLayer.push({
            'event': 'formError',
            'formName': 'checkSearch',
            'fieldName': 'search'
        });
        alert("Insert the search query, please.");
        form.search.focus();
        return false
    } else return true;
}